import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { People, Assignment } from "@mui/icons-material";

type InfoCardProps = {
  value: number | string;
  category: string;
  color?: string;
};

export const InfoCard = ({ value, category, color }: InfoCardProps) => {
  // Escolhe o ícone baseado na categoria
  const getIcon = () => {
    switch (category) {
      case "Usuários":
        return <People sx={{ fontSize: 40 }} />;
      case "Atendimentos":
        return <Assignment sx={{ fontSize: 40 }} />;
      default:
        return <People sx={{ fontSize: 40 }} />;
    }
  };

  return (
    <Paper
      elevation={3}
      sx={{
        width: 300,
        height: 100,
        borderRadius: 3,
        display: "flex",
        alignItems: "center",
        padding: 2,
        backgroundColor: color || "#e3f2fd",
      }}
    >
      <Box sx={{ marginRight: 2 }}>{getIcon()}</Box>
      <Box>
        <Typography variant="h5" component="div" fontWeight="bold">
          {value}
        </Typography>
        <Typography variant="body1" component="div">
          {category}
        </Typography>
      </Box>
    </Paper>
  );
};

export default InfoCard;
